// src/pages/Puzzle.jsx
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PuzzleScreen from '../components/PuzzleScreen'
import HuntCompleteScreen from '../components/HuntCompleteScreen'
import { savePuzzleCompletion, fetchHunt } from '../utils/kv'
import { getHuntCache, getProgress, saveProgress } from '../utils/offline'

export default function Puzzle() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [hunt, setHunt] = useState(null)
  const [loading, setLoading] = useState(true)
  const [progress, setProgress] = useState(null)

  useEffect(() => {
    async function loadHunt() {
      // Try to fetch fresh hunt from KV
      let huntData = await fetchHunt()

      // Fall back to cache if fetch fails
      if (!huntData) {
        huntData = await getHuntCache()
      }

      if (!huntData) {
        navigate('/')
        return
      }

      const prog = await getProgress()
      setHunt(huntData)
      setProgress(prog)
      setLoading(false)
    }

    loadHunt()
  }, [navigate])

  async function handlePuzzleComplete() {
    const progress = await getProgress()
    await saveProgress({
      ...progress,
      puzzleCompleted: true,
      puzzleCompletedAt: Date.now()
    })

    await savePuzzleCompletion()
  }

  if (loading) {
    return <div style={styles.container}>{t('hunt.loading')}</div>
  }

  if (!hunt) {
    return <div style={styles.container}>{t('hunt.notFound')}</div>
  }

  // Proximity hunts have no word puzzle — arriving at the last treasure ends it
  if (hunt.unlockMode === 'proximity') {
    return (
      <div style={styles.container}>
        <HuntCompleteScreen
          hint={hunt.finalHint}
          onComplete={handlePuzzleComplete}
          initialCompleted={Boolean(progress?.puzzleCompleted)}
        />
      </div>
    )
  }

  // If puzzle already completed, show the completion screen
  if (progress && progress.puzzleCompleted) {
    return (
      <div style={styles.container}>
        <PuzzleScreen
          words={hunt.finalWords}
          hint={hunt.finalHint}
          onComplete={handlePuzzleComplete}
          initialCompleted={true}
        />
      </div>
    )
  }

  return (
    <div style={styles.container}>
      <PuzzleScreen
        words={hunt.finalWords}
        hint={hunt.finalHint}
        onComplete={handlePuzzleComplete}
      />
    </div>
  )
}

const styles = {
  container: {
    width: '100%',
    minHeight: '100vh',
    background: '#f5f5f5'
  }
}
